<template>
  <v-dialog v-model="isShow" width="400" @click:outside="close">
    <v-card>
      <v-card-title :style="`background: ${type === 'duo' ? '#FF4040' : '#7E69FF'}`" style="color: white; word-break: normal">
        <div class="mb-2">{{homeworks.title}}</div>
      </v-card-title>
      <v-card-text style="padding-left: 0; padding-right: 0">
        <div class="align-center" style="height: 350px; overflow: auto">
          <div
            v-for="(item, index) in homeworks.homeworkDetail"
            :key="'homework' + index"
            class="d-flex mb-2"
            style="color: #0180C7; font-size: 18px; padding-left: 80px">
            <img src="../student_detail_bt/assets/homework-icon.svg" alt="" class="mr-4">
            <template v-if="item.linkResult">
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer; font-weight: bold; color: #0088FF">{{'BT' + (index + 1)}}</span>
                </template>
                <div>Xem đề bài</div>
              </v-tooltip>
              :
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <span @click="handleRedirect(item.linkResult)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer; color: #0088FF; font-weight: bold;">{{item.score}}</span>
                </template>
                <div>Xem kết quả</div>
              </v-tooltip>
            </template>
            <template v-else>
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                      <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" style="color: #0088FF; font-weight: bold;cursor: pointer" class="hover-to-underline">
                        {{'BT' + (index + 1)}}: Chưa làm
                      </span>
                </template>
                <div>Xem đề bài</div>
              </v-tooltip>
            </template>
<!--            Bài tập {{index + 1}}: <span class="ml-4">{{item.score}}</span>-->
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn :color="`${type === 'duo' ? '#FCC2BA' : '#FF5555'}`" style="color: white" @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HomeworkDialog',
  props: {
    type: {
      type: String,
      default: () => null,
    },
    homeworks: {
      type: Object,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleRedirect(link) {
      window.open(link);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
